import React from 'react';

function SuperstarSkeleton() {
  return (
    <div className="box-border pt-10 md:pb-[30px] md:pl-[30px] md:pr-[30px]">
      <div className="box-border md:ml-[15px] md:mr-[15px] md:flex">
        <div className="flex-basis-0 relative box-border w-full max-w-full flex-grow md:pl-[15px] md:pr-[15px]">
          <div className="mb-[30px] box-border md:hidden">
            <div className="bg-back200 relative mb-[30px] box-border block h-4 w-auto max-w-[150px] overflow-hidden rounded"></div>
          </div>
          <div className="mb-[30px] box-border hidden md:block">
            <div className="bg-back200 relative mb-5 box-border block h-[25px] w-auto max-w-[400px] overflow-hidden rounded"></div>
            <div className="box-border">
              <div className="bg-back200 relative mb-[10px] box-border block h-[12px] w-auto overflow-hidden rounded"></div>
              <div className="bg-back200 relative mb-[10px] box-border block h-[12px] w-auto overflow-hidden rounded"></div>
              <div className="bg-back200 relative mb-[10px] box-border block h-[12px] w-auto overflow-hidden rounded"></div>
            </div>
          </div>
          <div className="box-border">
            <div className="bg-back200 relative mb-[30px] box-border block h-4 w-auto max-w-[150px] overflow-hidden rounded"></div>
            <div className="mx-[-10px] box-border flex flex-wrap">
              <div className="relative mb-5 box-border w-full max-w-[33.3333%] flex-[0_0_33.3333%] px-[10px]">
                <div className="box-border flex w-full flex-col items-center rounded-lg text-center">
                  <div className="bg-back400 box-border w-full rounded p-[15px]">
                    <div className="bg-back200 relative box-border block h-[150px] w-auto overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
              <div className="relative mb-5 box-border w-full max-w-[33.3333%] flex-[0_0_33.3333%] px-[10px]">
                <div className="box-border flex w-full flex-col items-center rounded-lg text-center">
                  <div className="bg-back400 box-border w-full rounded p-[15px]">
                    <div className="bg-back200 relative box-border block h-[150px] w-auto overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
              <div className="relative mb-5 box-border w-full max-w-[33.3333%] flex-[0_0_33.3333%] px-[10px]">
                <div className="box-border flex w-full flex-col items-center rounded-lg text-center">
                  <div className="bg-back400 box-border w-full rounded p-[15px]">
                    <div className="bg-back200 relative box-border block h-[150px] w-auto overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="-ml-[15px] -mr-[15px] box-border flex flex-wrap">
            <div className="relative box-border w-full max-w-full flex-[0_0_100%] pl-[15px] pr-[15px]">
              <div className="bg-back400 mb-[30px] box-border w-full rounded-lg pb-[10px] pl-[30px] pr-[30px] pt-[25px]">
                <div className="pointer-events-none invisible absolute inset-0 z-[-1] box-border overflow-hidden">
                  <div className="pointer-events-none invisible absolute inset-0 z-[-1] box-border overflow-hidden">
                    <div className="absolute left-0 top-0 box-border h-[1e+06px] w-[1e+06px]"></div>
                  </div>
                  <div className="pointer-events-none invisible absolute inset-0 z-[-1] box-border overflow-hidden">
                    <div className="absolute left-0 top-0 box-border h-[1186px] w-[200%]"></div>
                  </div>
                </div>
                <div className="box-border flex w-full justify-between pt-[10px]">
                  <div className="box-border w-full">
                    <div className="relative mr-[15px] mt-[10px] box-border block h-4 w-auto max-w-[150px] overflow-hidden rounded-lg bg-[#6a73b5]"></div>
                    <div className="relative mt-[5px] box-border block h-[10px] w-auto max-w-[100px] overflow-hidden rounded-lg bg-[#4f5794]"></div>
                  </div>
                  <div className="box-border flex w-full justify-between">
                    <div className="box-border flex w-full items-center justify-center">
                      <div className="bg-back200 relative mr-[15px] box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                      <div className="box-border w-full">
                        <div className="bg-back200 relative mr-[15px] mt-[10px] box-border block h-[14px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                        <div className="relative mt-[5px] box-border block h-[10px] w-auto max-w-[70px] overflow-hidden rounded bg-[#4f5794]"></div>
                      </div>
                    </div>
                    <div className="box-border flex w-full items-center justify-center">
                      <div className="bg-back200 relative mr-[15px] box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                      <div className="box-border w-full">
                        <div className="bg-back200 relative mr-[15px] mt-[10px] box-border block h-[14px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                        <div className="relative mt-[5px] box-border block h-[10px] w-auto max-w-[70px] overflow-hidden rounded bg-[#4f5794]"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="bg-back200 mb-[30px] mt-[30px] box-border h-[1px] w-full overflow-visible border-t border-t-[rgba(0,0,0,0.1)]" />
                <canvas
                  width="879"
                  height="415"
                  className="animation-[chartjs-render-animation_0.001s_ease_0s_1_normal_none_running] box-border block h-[415px] max-h-full w-[879px] max-w-full"
                ></canvas>
              </div>
            </div>
            <div className="relative box-border w-full max-w-full flex-[0_0_100%] pl-[15px] pr-[15px]">
              <div className="bg-back400 mb-[30px] box-border w-full rounded-lg pb-[10px] pl-[30px] pr-[30px] pt-[25px]">
                <div className="pointer-events-none invisible absolute inset-0 z-[-1] box-border overflow-hidden">
                  <div className="pointer-events-none invisible absolute inset-0 z-[-1] box-border overflow-hidden">
                    <div className="absolute left-0 top-0 box-border h-[1e+06px] w-[1e+06px]"></div>
                  </div>
                  <div className="pointer-events-none invisible absolute inset-0 z-[-1] box-border overflow-hidden">
                    <div className="absolute left-0 top-0 box-border h-[1186px] w-[200%]"></div>
                  </div>
                </div>
                <div className="box-border flex w-full justify-between pt-[10px]">
                  <div className="box-border w-full">
                    <div className="relative mr-[15px] mt-[10px] box-border block h-4 w-auto max-w-[150px] overflow-hidden rounded-lg bg-[#6a73b5]"></div>
                    <div className="relative mt-[5px] box-border block h-[10px] w-auto max-w-[100px] overflow-hidden rounded-lg bg-[#4f5794]"></div>
                  </div>
                  <div className="box-border flex w-full justify-between">
                    <div className="box-border flex w-full items-center justify-center">
                      <div className="bg-back200 relative mr-[15px] box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                      <div className="box-border w-full">
                        <div className="bg-back200 relative mr-[15px] mt-[10px] box-border block h-[14px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                        <div className="relative mt-[5px] box-border block h-[10px] w-auto max-w-[70px] overflow-hidden rounded bg-[#4f5794]"></div>
                      </div>
                    </div>
                    <div className="box-border flex w-full items-center justify-center">
                      <div className="bg-back200 relative mr-[15px] box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                      <div className="box-border w-full">
                        <div className="bg-back200 relative mr-[15px] mt-[10px] box-border block h-[14px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                        <div className="relative mt-[5px] box-border block h-[10px] w-auto max-w-[70px] overflow-hidden rounded bg-[#4f5794]"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="bg-back200 mb-[30px] mt-[30px] box-border h-[1px] w-full overflow-visible border-t border-t-[rgba(0,0,0,0.1)]" />
                <canvas
                  width="879"
                  height="415"
                  className="animation-[chartjs-render-animation_0.001s_ease_0s_1_normal_none_running] box-border block h-[415px] max-h-full w-[879px] max-w-full"
                ></canvas>
              </div>
            </div>
          </div>
          <div className="m-0 -mx-[10px] mb-5 box-border flex flex-wrap">
            <div className="relative mb-5 box-border w-full max-w-[25%] flex-[0_0_25%] px-[10px]">
              <div className="bg-back200 relative box-border block h-4 w-auto max-w-[120px] overflow-hidden rounded"></div>
              <div className="bg-back200 relative mt-[10px] box-border block h-[52px] w-auto max-w-[400px] overflow-hidden rounded"></div>
            </div>
            <div className="relative mb-5 box-border w-full max-w-[25%] flex-[0_0_25%] px-[10px]">
              <div className="bg-back200 relative box-border block h-4 w-auto max-w-[120px] overflow-hidden rounded"></div>
              <div className="bg-back200 relative mt-[10px] box-border block h-[52px] w-auto max-w-[400px] overflow-hidden rounded"></div>
            </div>
            <div className="relative mb-5 box-border w-full max-w-[50%] flex-[1_0_50%] flex-grow px-[10px]">
              <div className="bg-back200 relative box-border block h-4 w-auto max-w-[120px] overflow-hidden rounded"></div>
              <div className="bg-back200 relative mt-[10px] box-border block h-[52px] w-auto max-w-[700px] overflow-hidden rounded"></div>
            </div>
          </div>
          <div className="m-0 -mx-[10px] mb-10 box-border flex flex-wrap">
            <div className="relative mb-[10px] box-border w-full max-w-[25%] flex-[0_0_25%] px-[10px]">
              <div className="m-0 -mx-[10px] box-border flex flex-wrap">
                <div className="relative box-border w-full max-w-full flex-[0_0_100%] px-[10px]">
                  <div className="bg-back400 mb-[10px] box-border flex items-center rounded px-5 py-[10px]">
                    <div className="bg-back200 relative box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                    <div className="ml-[10px] box-border w-full">
                      <div className="bg-back200 relative mb-[5px] box-border block h-[12px] w-auto max-w-[120px] overflow-hidden rounded"></div>
                      <div className="bg-back200 relative box-border block h-[10px] w-auto max-w-[120px] overflow-hidden rounded"></div>
                    </div>
                  </div>
                </div>
                <div className="relative box-border w-full max-w-full flex-[0_0_100%] px-[10px]">
                  <div className="bg-back400 box-border flex items-center rounded px-5 py-[10px]">
                    <div className="bg-back200 relative box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                    <div className="ml-[10px] box-border w-full">
                      <div className="bg-back200 relative mb-[5px] box-border block h-[12px] w-auto max-w-[120px] overflow-hidden rounded"></div>
                      <div className="bg-back200 relative box-border block h-[10px] w-auto max-w-[120px] overflow-hidden rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative mb-[10px] box-border w-full max-w-[75%] flex-[0_0_75%] px-[10px]">
              <div className="bg-back400 box-border flex h-[110px] items-center justify-between rounded px-[30px] py-5">
                <div className="box-border w-full text-center">
                  <div className="bg-back200 relative m-auto box-border block h-[40px] w-auto max-w-[40px] overflow-hidden rounded-full"></div>
                  <div className="bg-back200 relative m-auto mt-[10px] box-border block h-[10px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                </div>
                <div className="box-border w-full text-center">
                  <div className="bg-back200 relative m-auto box-border block h-[40px] w-auto max-w-[40px] overflow-hidden rounded-full"></div>
                  <div className="bg-back200 relative m-auto mt-[10px] box-border block h-[10px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                </div>
                <div className="box-border w-full text-center">
                  <div className="bg-back200 relative m-auto box-border block h-[40px] w-auto max-w-[40px] overflow-hidden rounded-full"></div>
                  <div className="bg-back200 relative m-auto mt-[10px] box-border block h-[10px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                </div>
                <div className="box-border w-full text-center">
                  <div className="bg-back200 relative m-auto box-border block h-[40px] w-auto max-w-[40px] overflow-hidden rounded-full"></div>
                  <div className="bg-back200 relative m-auto mt-[10px] box-border block h-[10px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                </div>
                <div className="box-border w-full text-center">
                  <div className="bg-back200 relative m-auto box-border block h-[40px] w-auto max-w-[40px] overflow-hidden rounded-full"></div>
                  <div className="bg-back200 relative m-auto mt-[10px] box-border block h-[10px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                </div>
                <div className="box-border w-full text-center">
                  <div className="bg-back200 relative m-auto box-border block h-[40px] w-auto max-w-[40px] overflow-hidden rounded-full"></div>
                  <div className="bg-back200 relative m-auto mt-[10px] box-border block h-[10px] w-auto max-w-[50px] overflow-hidden rounded"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-1[10px] box-border">
            <div className="bg-back200 relative mb-[30px] box-border block h-4 w-auto max-w-[150px] overflow-hidden rounded"></div>
            <div className="-ml-[15px] -mr-[15px] box-border flex flex-wrap">
              {[1, 2, 3, 4].map((item) => (
                <div
                  key={item}
                  className="relative box-border w-full max-w-full flex-[0_0_100%] pl-[15px] pr-[15px]"
                >
                  <div className="bg-back400 mb-[10px] ml-0 mr-0 box-border flex flex-wrap rounded">
                    <div className="relative box-border w-full max-w-[25%] flex-[0_0_25%] pl-0 pr-0">
                      <div className="box-border flex flex-col items-center justify-center border-r-0 p-5">
                        <div className="bg-back200 relative mb-[10px] box-border block h-[30px] w-auto max-w-[30px] overflow-hidden rounded-full"></div>
                        <div className="bg-back200 relative mb-[10px] box-border block h-[10px] w-auto max-w-[100px] overflow-hidden rounded"></div>
                        <div className="bg-back200 relative box-border block h-5 w-auto max-w-[60px] overflow-hidden rounded"></div>
                      </div>
                    </div>
                    <div className="relative box-border w-full max-w-[75%] flex-[0_0_75%] pl-0 pr-0">
                      <div className="box-border p-5">
                        <div className="bg-back200 relative mb-[10px] box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                        <div className="bg-back200 relative mb-[10px] box-border block h-5 w-auto overflow-hidden rounded"></div>
                        <div className="box-border max-w-[400px]">
                          <div className="bg-back200 relative box-border block h-5 w-auto max-w-[400px] overflow-hidden rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mb-1[10px] box-border">
            <div className="bg-back200 relative mb-[30px] box-border block h-4 w-auto max-w-[180px] overflow-hidden rounded"></div>
            <div className="bg-back400 box-border rounded p-5">
              <div className="mb-[15px] box-border">
                <div className="-ml-[15px] -mr-[15px] box-border flex flex-wrap">
                  <div className="box-border flex w-full pl-[15px] pr-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[150px] overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
              <div className="box-border">
                <div className="box-border rounded-lg bg-[#272b4a]">
                  <div className="-ml-[15px] -mr-[15px] mb-[5px] box-border flex flex-wrap items-center p-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                  </div>
                </div>
                <div className="box-border">
                  <div className="-ml-[15px] -mr-[15px] mb-[5px] box-border flex flex-wrap items-center p-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                  </div>
                </div>
                <div className="box-border rounded-lg bg-[#272b4a]">
                  <div className="-ml-[15px] -mr-[15px] mb-[5px] box-border flex flex-wrap items-center p-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-1[10px] box-border">
            <div className="bg-back200 relative mb-[30px] box-border block h-4 w-auto max-w-[180px] overflow-hidden rounded"></div>
            <div className="bg-back400 box-border rounded p-5">
              <div className="mb-[15px] box-border">
                <div className="-ml-[15px] -mr-[15px] box-border flex flex-wrap">
                  <div className="box-border flex w-full pl-[15px] pr-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[150px] overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
              <div className="box-border">
                <div className="box-border rounded-lg bg-[#272b4a]">
                  <div className="-ml-[15px] -mr-[15px] mb-[5px] box-border flex flex-wrap items-center p-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                  </div>
                </div>
                <div className="box-border">
                  <div className="-ml-[15px] -mr-[15px] mb-[5px] box-border flex flex-wrap items-center p-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                  </div>
                </div>
                <div className="box-border rounded-lg bg-[#272b4a]">
                  <div className="-ml-[15px] -mr-[15px] mb-[5px] box-border flex flex-wrap items-center p-[15px]">
                    <div className="bg-back200 relative ml-5 mr-[30px] box-border block h-5 w-auto max-w-[100px] overflow-hidden rounded"></div>
                    <div className="bg-back200 relative box-border block h-5 w-auto max-w-[200px] overflow-hidden rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuperstarSkeleton;
